import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    button: {
      flex: 1,
    },
    inputTitleStyle: {
      marginBottom: 8,
      marginTop: 24,
    },
    dropdownModal: {
      width: '30%',
      alignSelf: 'flex-end',
    },
  });

export default makeStyles;
